export default "__VITE_ASSET__bc9708eb__"